<template>
  <div class="approval-container">
    <!-- 组织结构部分 -->
    <el-card>
      <template #header>
        <div class="flex justify-between items-center">
          <span>组织结构管理</span>
          <el-button size="small" type="primary" @click="showAddDepartmentDialog">添加部门</el-button>
        </div>
      </template>

      <!-- 部门-团队层级表格 -->
      <el-table 
        :data="departmentsWithTeams" 
        style="width: 100%"
        row-key="id"
        :tree-props="{ children: 'teams' }"
        :default-expand-all = "true"
      >
        <!-- <el-table-column prop="id" label="ID" width="80"></el-table-column> -->
        <el-table-column prop="name" label="名称" width="300"></el-table-column>
        <el-table-column prop="leader" label="负责人"></el-table-column>
        <el-table-column prop="type" label="类型" width="100">
          <template #default="scope">
            {{ scope.row.type === 'department' ? '部门' : '团队' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="30%">
          <template #default="scope">
            <div v-if="scope.row.type === 'department'">
              <el-button size="mini" @click="showEditDepartmentDialog(scope.row)">编辑</el-button>
              <el-button size="mini" type="danger" @click="deleteDepartment(scope.row.id)">删除</el-button>
              <el-button size="mini" type="primary" @click="showAddTeamDialog(scope.row.id)">添加团队</el-button>
            </div>
            <div v-else>
              <el-button size="mini" @click="showEditTeamDialog(scope.row)">编辑</el-button>
              <el-button size="mini" type="danger" @click="deleteTeam(scope.row.id)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 团队管理对话框 -->
    <el-dialog v-model="teamDialogVisible" title="团队管理" width="50%">
      <div class="mb-4">
        <el-button size="small" type="primary" @click="showAddTeamDialog">添加团队</el-button>
      </div>
      <el-table :data="currentDepartmentTeams" style="width: 100%">
        <el-table-column prop="id" label="团队ID" width="80"></el-table-column>
        <el-table-column prop="name" label="团队名称"></el-table-column>
        <el-table-column prop="leader" label="团队领导"></el-table-column>
        <el-table-column label="操作" width="160">
          <template #default="scope">
            <el-button size="mini" @click="showEditTeamDialog(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="deleteTeam(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template #footer>
        <el-button @click="teamDialogVisible = false">关闭</el-button>
      </template>
    </el-dialog>

    <!-- 添加/编辑部门对话框 -->
    <el-dialog v-model="departmentDialogVisible" :title="isEditDepartment ? '编辑部门' : '添加部门'" width="30%">
      <el-form :model="departmentForm" label-width="80px">
        <el-form-item label="部门名称" prop="name">
          <el-input v-model="departmentForm.name"></el-input>
        </el-form-item>
        <el-form-item label="部门领导" prop="leaderId">
          <el-select v-model="departmentForm.leaderId" placeholder="请选择部门领导" filterable>
            <el-option
              v-for="user in leaderMap['MANAGER'] || []"
              :key="user.id"
              :label="user.username"
              :value="user.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="departmentDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveDepartment">确认</el-button>
      </template>
    </el-dialog>

    <!-- 添加/编辑团队对话框 -->
    <el-dialog v-model="teamFormDialogVisible" :title="isEditTeam ? '编辑团队' : '添加团队'" width="30%">
      <el-form :model="teamForm" label-width="80px">
        <el-form-item label="团队名称" prop="name">
          <el-input v-model="teamForm.name"></el-input>
        </el-form-item>
        <el-form-item label="团队领导" prop="leaderId">
          <el-select v-model="teamForm.leaderId" placeholder="请选择团队领导" filterable>
            <el-option
              v-for="user in leaderMap['SUPERVISOR'] || []"
              :key="user.id"
              :label="user.username"
              :value="user.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="teamFormDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveTeam">确认</el-button>
      </template>
    </el-dialog>

    <!-- 待审批用户部分 -->
    <el-card style="margin-top: 20px;">
      <template #header>
        <span>待审批用户</span>
      </template>

      <el-table :data="pendingUsers" style="width: 100%">
        <el-table-column prop="username" label="用户名"></el-table-column>
        <el-table-column prop="role" label="角色">
            <template #default="scope">
                {{ 
                   scope.row && Object.values(UserRole).find(r => r.value === scope.row.role)?.label || (scope.row?.role || '无')
                }}
            </template>
        </el-table-column>
        <!-- <el-table-column prop="departmentName" label="部门"></el-table-column>
        <el-table-column prop="teamName" label="团队"></el-table-column> -->
        <el-table-column prop="createTime" label="注册时间"></el-table-column>
        <el-table-column label="操作" width="200">
          <template #default="scope">
            <el-button size="mini" type="success" @click="handleApprove(scope.row.id)">批准</el-button>
            <el-button size="mini" type="danger" @click="handleReject(scope.row.id)">拒绝</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-card style="margin-top: 20px;">
      <template #header>
        <div class="flex justify-between items-center">
          <span>已批准用户</span>
          <el-input
            v-model="searchKeyword"
            placeholder="搜索用户名"
            clearable
            style="width: 200px;"
          />
        </div>
      </template>

      <el-table :data="filteredApprovedUsers" style="width: 100%">
        <el-table-column prop="username" label="用户名"></el-table-column>
        <el-table-column label="角色">
              <template #default="scope">
                {{ 
                   scope.row && Object.values(UserRole).find(r => r.value === scope.row.role)?.label || (scope.row?.role || '无')
                }}
              </template>
        </el-table-column>
        <el-table-column prop="department.name" label="部门"></el-table-column>
        <el-table-column prop="department.leader" label="部门领导"></el-table-column>
        <el-table-column prop="team.name" label="团队"></el-table-column>
        <el-table-column prop="team.leader" label="团队领导"></el-table-column>
        <el-table-column prop="createTime" label="注册时间"></el-table-column>
        <el-table-column label="操作" width="260">
          <template #default="scope">
            <div class="button-group">
              <el-button 
                size="small" 
                type="primary" 
                @click="showAssignDialog(scope.row)"
              >{{ scope.row.role === UserRole.ADMIN.value || scope.row.role === UserRole.ACCOUNTANT.value || scope.row.role === UserRole.OTHER.value ? '角色分配' : '部门分配' }}</el-button>
              <el-button 
                size="small" 
                type="warning" 
                @click="showChangePasswordConfirm(scope.row)"
              >修改密码</el-button>
              <el-button 
                size="small" 
                type="danger" 
                @click="showDeleteConfirm(scope.row.id)"
              >删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog
      v-model="deleteDialogVisible"
      title="确认删除"
      width="30%"
    >
      <span>确定要删除该用户吗？此操作不可撤销。</span>
      <template #footer>
        <el-button @click="deleteDialogVisible = false">取消</el-button>
        <el-button type="danger" @click="confirmDelete">确认删除</el-button>
      </template>
    </el-dialog>

    <!-- 修改用户密码-->
    <el-dialog
      v-model="changePasswordDialogVisible"
      title="修改用户密码"
      width="30%"
    >
      <el-form :model="changePasswordForm" :rules="changePasswordRules" ref="changePasswordFormRef" label-width="100px">    
        <el-form-item label="用户名">
          <el-input v-model="changePasswordForm.username" disabled></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="changePasswordForm.newPassword" type="password"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPassword">
          <el-input v-model="changePasswordForm.confirmPassword" type="password"></el-input>
        </el-form-item>
      </el-form>
       <template #footer>
        <el-button @click="changePasswordDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmChangePassword">确认修改</el-button>
      </template>
    </el-dialog>

    <!-- 部门分配对话框 -->
    <el-dialog v-model="assignDialogVisible" title="部门分配" width="30%">
      <el-form :model="assignForm" label-width="80px">
        <el-form-item label="用户名">
          <el-input v-model="assignForm.username" disabled></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="role">
          <el-select v-model="assignForm.role" placeholder="请选择角色" @change="handleRoleChange">
            <el-option
              v-for="(role, key) in UserRole"
              :key="key"
              :label="role.label"
              :value="role.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门" prop="departmentId" v-if="assignForm.role !== UserRole.ADMIN.value && assignForm.role !== UserRole.ACCOUNTANT.value && assignForm.role !== UserRole.OTHER.value">
          <el-select v-model="assignForm.departmentId" placeholder="请选择部门" @change="handleDepartmentChange">
            <el-option
              v-for="dept in departments"
              :key="dept.id"
              :label="dept.name"
              :value="dept.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="团队" prop="teamId" v-if="assignForm.role !== UserRole.ADMIN.value && assignForm.role !== UserRole.ACCOUNTANT.value && assignForm.role !== UserRole.OTHER.value &&assignForm.role !== UserRole.MANAGER.value">
          <el-select v-model="assignForm.teamId" placeholder="请选择团队">
            <el-option
              v-for="team in filteredTeams"
              :key="team.id"
              :label="team.name"
              :value="team.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="assignDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmAssign">确认分配</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, onMounted, computed } from 'vue'
import { useStore } from 'vuex'
import { ElMessage, ElMessageBox } from 'element-plus'
import { UserStatus, UserRole } from '@/store'

export default {
  setup() {
    const store = useStore()
    const userMap = computed(() => {
      const map = {}
      store.state.users.forEach(user => {
        if (user.status === UserStatus.APPROVED.value) {
          map[user.id] = user
        }
      })
      return map
    })
    const leaderMap = computed(()=>{
      const map = {}
      store.state.users.forEach(user=>{
        if (user.status === UserStatus.APPROVED.value) {
          if(!map[user.role]){
           map[user.role] = [];
          }
           map[user.role].push(user);
        }
      });
      return map;
    })
    // 组织结构相关数据
    const departments = computed(() => { return store.state.departments.map(d => ({
      ...d,
      leader: userMap.value[d.leaderId]?.username || '待分配'
    })) })
    const teams = computed(() => { return store.state.teams.map(t => ({
      ...t,
      leader: userMap.value[t.leaderId]?.username || '待分配'
    })) })
    const currentDepartmentId = ref(null)
    const currentDepartmentTeams = computed(() => {
      return teams.value.filter(team => team.departmentId === currentDepartmentId.value)
    })

    // 对话框状态
    const departmentDialogVisible = ref(false)
    const teamDialogVisible = ref(false)
    const teamFormDialogVisible = ref(false)
    const isEditDepartment = ref(false)
    const isEditTeam = ref(false)

    // 表单数据
    const departmentForm = ref({
      id: null,
      name: '',
      leaderId: ''
    })

    const teamForm = ref({
      id: null,
      name: '',
      leaderId: '',
      departmentId: null
    })

    const changePasswordFormRef = ref(null)

    // 初始化加载数据
    onMounted(() => {
      store.dispatch('fetchUsers')
      store.dispatch('fetchTeams')
      store.dispatch('fetchDepartments')
    })

    // 显示添加部门对话框
    const showAddDepartmentDialog = () => {
      isEditDepartment.value = false
      departmentForm.value = {
        id: null,
        name: '',
        superiorId: null
      }
      departmentDialogVisible.value = true
    }

    // 显示编辑部门对话框
    const showEditDepartmentDialog = (department) => {
      isEditDepartment.value = true
      departmentForm.value = {
        ...department,
        leaderId: department.leaderId
      }
      departmentDialogVisible.value = true
    }

    // 保存部门
    const saveDepartment = async () => {
      try {
        if (isEditDepartment.value) {
          // 调用编辑部门方法
          await store.dispatch('setDepartment', departmentForm.value)
          ElMessage.success('部门更新成功')
        } else {
          // 调用添加部门方法
          await store.dispatch('setDepartment', departmentForm.value)
          ElMessage.success('部门添加成功')
        }
        departmentDialogVisible.value = false
        store.dispatch('fetchUsers')
        store.dispatch('fetchDepartments')
      } catch (error) {
        ElMessage.error('操作失败: ' + error.message)
      }
    }

    // 删除部门
    const deleteDepartment = async (id) => {
      try {
        await ElMessageBox.confirm('确定要删除该部门吗？部门下的团队也会被删除。', '确认删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        await store.dispatch('deleteDepartment', { id })
        ElMessage.success('部门删除成功')
        store.dispatch('fetchUsers')
        store.dispatch('fetchDepartments')
      } catch (error) {
        if (error === 'cancel') return
        ElMessage.error('删除失败: ' + error.message)
      }
    }

    // 显示团队管理对话框
    const showTeamDialog = (departmentId) => {
      currentDepartmentId.value = departmentId
      teamDialogVisible.value = true
    }

    // 显示添加团队对话框
    const showAddTeamDialog = (departmentId) => {
      currentDepartmentId.value = departmentId
      isEditTeam.value = false
      teamForm.value = {
        id: null,
        name: '',
        superiorId: departmentId,
        departmentId: departmentId
      }
      teamFormDialogVisible.value = true
    }

    // 显示编辑团队对话框
    const showEditTeamDialog = (team) => {
      isEditTeam.value = true
      teamForm.value = {
        ...team,
        leaderId: team.leaderId,
        superiorId: team.departmentId
      }
      teamFormDialogVisible.value = true
    }

    // 保存团队
    const saveTeam = async () => {
      try {
        if (isEditTeam.value) {
          // 调用编辑团队方法
          await store.dispatch('setTeam', teamForm.value)
          ElMessage.success('团队更新成功')
        } else {
          // 调用添加团队方法
          await store.dispatch('setTeam', teamForm.value)
          ElMessage.success('团队添加成功')
        }
        teamFormDialogVisible.value = false
        store.dispatch('fetchUsers')
        store.dispatch('fetchTeams')
      } catch (error) {
        ElMessage.error('操作失败: ' + error.message)
      }
    }

    // 删除团队
    const deleteTeam = async (id) => {
      try {
        await ElMessageBox.confirm('确定要删除该团队吗？', '确认删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        await store.dispatch('deleteTeam', { id })
        ElMessage.success('团队删除成功')
        store.dispatch('fetchUsers')
        store.dispatch('fetchTeams')
      } catch (error) {
        if (error === 'cancel') return
        ElMessage.error('删除失败: ' + error.message)
      }
    }

     const validatePass = (rule, value, callback) => {
      if (value !== changePasswordForm.value.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }

    const changePasswordRules = {
      newPassword: [
        { required: true, message: '请输入新密码', trigger: 'blur' },
        { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
      ],
      confirmPassword: [
        { required: true, message: '请确认新密码', trigger: 'blur' },
        { validator: validatePass, trigger: 'blur' }
      ]
    }

    const deleteDialogVisible = ref(false)
    const deletingUserId = ref(null)
    const changePasswordDialogVisible = ref(false)

    // 部门分配相关数据
    const assignDialogVisible = ref(false)
    const assignForm = ref({
      id: null,
      username: '',
      role: '',
      departmentId: null,
      teamId: null
    })
    const changePasswordForm = ref({
      id: null,
      username: '',
      newPassword: '',
      confirmPassword: ''
    })
    const filteredTeams = computed(() => {
      if (!assignForm.value.departmentId) return []
      return teams.value.filter(team => team.departmentId === assignForm.value.departmentId)
    })
    
    // 构建部门和团队的层级结构
    const departmentsWithTeams = computed(() => {
      // const dd = leaderMap.value || {};
      // console.log("value:", dd)
      // console.log("leaderMap[]:", dd['MANAGER'])
    // 先将所有团队按部门ID分组
    const teamsByDepartment = {};
    teams.value.forEach(team => {
    if (!teamsByDepartment[team.departmentId]) {
    teamsByDepartment[team.departmentId] = [];
    }
    teamsByDepartment[team.departmentId].push({
        ...team,
        type: 'team'
    });
    });

    // 为每个部门添加团队
    return departments.value.map(department => ({
    ...department,
    type: 'department',
    teams: teamsByDepartment[department.id] || [],
    hasTeams: !!teamsByDepartment[department.id]?.length
    }));
    });

    const pendingUsers = computed(() => {
      return store.state.users.filter(user => 
        user.status === UserStatus.APPLYING.value
      )
    })
    const searchKeyword = ref('')
    const approvedUsers =computed(() => {
      return store.state.users
        .filter(user => user.status === UserStatus.APPROVED.value)
        .map(user => {
          user.department = departments.value.find(d => d.id == user.departmentId) || {};
          user.team = teams.value.find(t => t.id == user.teamId) || {};
          return user;
        });
    })
    
    // 搜索过滤后的已批准用户
    const filteredApprovedUsers = computed(() => {
      if (!searchKeyword.value.trim()) {
        return approvedUsers.value
      }
      const keyword = searchKeyword.value.toLowerCase().trim()
      return approvedUsers.value.filter(user => 
        user.username.toLowerCase().includes(keyword)
      )
    })

    const handleApprove = async (userId) => {
      try {
        await store.dispatch('updateUser', {
          id: userId,
          status: UserStatus.APPROVED.value
        })
        ElMessage.success('用户已批准')
        store.dispatch('fetchUsers')
      } catch (error) {
        ElMessage.error('批准操作失败')
      }
    }

    const handleReject = async (userId) => {
      try {
        await store.dispatch('updateUser', {
          id: userId,
          status: UserStatus.REJECTED.value
        })
        ElMessage.success('用户已拒绝')
        store.dispatch('fetchUsers')
      } catch (error) {
        ElMessage.error('拒绝操作失败')
      }
    }

    const showDeleteConfirm = (userId) => {
      deletingUserId.value = userId
      deleteDialogVisible.value = true
    }

    const showChangePasswordConfirm = (user) => {
      changePasswordForm.value = {
        id: user.id,
        username: user.username,
        newPassword: '',
        confirmPassword: ''
      }
      console.log("showChangePasswordConfirm username:",changePasswordForm.value.username)
      changePasswordDialogVisible.value = true
    }

    const confirmDelete = async () => {
      try {
        await store.dispatch('updateUser', {
          id: deletingUserId.value,
          status: UserStatus.REMOVED.value
        })
        ElMessage.success('用户已删除')
        deleteDialogVisible.value = false
        store.dispatch('fetchUsers')
      } catch (error) {
        ElMessage.error('删除用户失败')
      }
    }

    // 显示部门分配对话框
    const showAssignDialog = (user) => {
      assignForm.value = {
        id: user.id,
        username: user.username,
        role: user.role,
        departmentId: user.departmentId || null,
        teamId: user.teamId || null
      }
      assignDialogVisible.value = true
    }

    // 处理角色变更
    const handleRoleChange = () => {
      // 当角色变化时，重置部门和团队
      assignForm.value.departmentId = null
      assignForm.value.teamId = null
    }

    // 处理部门变更
    const handleDepartmentChange = () => {
      assignForm.value.teamId = null
    }

    // 确认部门分配
    const confirmAssign = async () => {
      try {
        await store.dispatch('assignUserPlacement', {
          userId: assignForm.value.id,
          role: assignForm.value.role,
          departmentId: assignForm.value.departmentId,
          teamId: assignForm.value.teamId
        })
        ElMessage.success('部门分配成功')
        assignDialogVisible.value = false
        store.dispatch('fetchUsers')
      } catch (error) {
        ElMessage.error('部门分配失败: ' + error.message)
      }
    }

    const confirmChangePassword = async()=>{
      changePasswordFormRef.value.validate((valid) => {
        if (valid) {
          // 密码验证通过，执行密码修改逻辑
          store.dispatch('updatePassword', {
            userId: changePasswordForm.value.id,
            password: changePasswordForm.value.newPassword
          }).then(() => {
            ElMessage.success('密码修改成功')
            changePasswordDialogVisible.value = false
            store.dispatch('fetchUsers')
          }).catch(error => {
            ElMessage.error(error.message || '密码修改失败')
          })
        } else {
          ElMessage.error('请修正密码错误')
        }
      })
    }

    return {
      // 组织结构相关
      departmentsWithTeams,
      departments,
      teams,
      leaderMap,
      departmentDialogVisible,
      teamFormDialogVisible,
      isEditDepartment,
      isEditTeam,
      departmentForm,
      teamForm,
      
      // 方法
      showAddDepartmentDialog,
      showEditDepartmentDialog,
      saveDepartment,
      deleteDepartment,
      showAddTeamDialog,
      showEditTeamDialog,
      saveTeam,
      deleteTeam,

      // 原有用户审批相关
      pendingUsers,
      approvedUsers,
      filteredApprovedUsers,
      searchKeyword,
      deleteDialogVisible,
      handleApprove,
      handleReject,
      showDeleteConfirm,
      showChangePasswordConfirm,
      confirmDelete,

      changePasswordRules,
      confirmChangePassword,
      changePasswordDialogVisible,
      changePasswordForm,
      changePasswordFormRef,
      
      // 部门分配相关
      assignDialogVisible,
      assignForm,
      filteredTeams,
      showAssignDialog,
      confirmAssign,
      handleRoleChange,
      UserRole
    }
  }
}
</script>

<style scoped>
.approval-container {
  padding: 20px;
}

.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
}

.items-center {
  align-items: center;
}

.mb-4 {
  margin-bottom: 16px;
}

.button-group {
  display: flex;
  gap: 8px;
  width: 100%;
}

.button-group .el-button {
  flex: 1;
  text-align: center;
}
</style>